import React from 'react';
import { FaBell } from 'react-icons/fa';
import { useNotifications } from '../../contexts/NotificationContext';
import NotificationItem from './NotificationItem';
import css from './NotificationPanel.module.scss';

interface NotificationPanelProps {
  /** Fired when a row navigates, so the host can dismiss the panel. Clicking a
   *  row lands inside the header's click-outside boundary, so nothing else
   *  would close it. */
  onNavigate?: () => void;
}

const NotificationPanel: React.FC<NotificationPanelProps> = ({ onNavigate }) => {
  const { notifications, clearAll } = useNotifications();

  if (notifications.length === 0) {
    return (
      <div className={css.panel}>
        <div className={css.panelHeader}>
          <span className={css.panelTitle}>Notifications</span>
        </div>
        <div className={css.emptyState}>
          <FaBell className={css.emptyIcon} />
          <p>No notifications yet</p>
        </div>
      </div>
    );
  }

  return (
    <div className={css.panel}>
      <div className={css.panelHeader}>
        <div className={css.panelTitleGroup}>
          <span className={css.panelTitle}>Notifications</span>
          <span className={css.panelCount}>{notifications.length}</span>
        </div>
        <button className={css.clearAll} onClick={clearAll}>Clear all</button>
      </div>
      <div className={css.notificationList}>
        {notifications.map((notification) => (
          <NotificationItem
            key={notification.id}
            notification={notification}
            onNavigate={onNavigate}
          />
        ))}
      </div>
    </div>
  );
};

export default NotificationPanel;
